<template>
  <div class="width-medium mx-auto">
    <h2 class="heading-tiny text-grey mt-3 mb-1">{{ $t('opinion.opinionByCustomer') }}</h2>
    <template v-if="$store.getters.getUserHasFeature('comments')">
      <f-opinion
        :opinion="opinion" />
    </template>
    <template v-else>
      <f-alert
        visible
        class="my-2"
        theme="inactive">
        <span>
        {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
        </span>
      </f-alert>
    </template>
  </div>
</template>
<script>
import FOpinion from '@/components/layout/FOpinion.vue'

export default {
  name: 'inquiry-opinion',
  components: { FOpinion },
  props: {
    opinion: {
      type: Object,
      required: true
    }
  }
}
</script>

